module.exports = __webpack_public_path__ + "img/upper_pocket_entry_length.444bc7cf.png";